import React, { useState } from "react";
import { Col, Table } from "react-bootstrap";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import ImageViewer from "../../components/ImageViewer";
import { UserDetail } from "../../components/ItemDetail";
import { formatAmountINR, to3 } from "../../utils/helper";

const ViewExpenseApproveData = ({ edit }) => {
  const summary = edit?.summary;
  const complaints = edit?.complaints ?? [];
  const [expandedItems, setExpandedItems] = useState({});

  // Group items by item_id across all complaints
  const itemMap = {};
  complaints.forEach((complaint) => {
    (complaint.items ?? []).forEach((itm) => {
      if (!itemMap[itm.item_id]) {
        itemMap[itm.item_id] = {
          item_id: itm.item_id,
          item_name: itm.item_name,
          item_images: itm.item_images,
          item_price: itm.item_price,
          total_approved_qty: 0,
          total_approved_amount: 0,
          complaint_rows: [],
        };
      }
      itemMap[itm.item_id].total_approved_qty += Number(itm.item_approved_qty ?? 0);
      itemMap[itm.item_id].total_approved_amount += Number(itm.approved_amount ?? 0);
      itemMap[itm.item_id].complaint_rows.push({
        complaint_unique_id: complaint.complaint_unique_id,
        punch_at: itm.punch_at,
        approved_at: itm.approved_at,
        item_approved_qty: itm.item_approved_qty,
        approved_amount: itm.approved_amount,
      });
    });
  });
  const uniqueItems = Object.values(itemMap);

  const toggleExpand = (item_id) => {
    setExpandedItems((prev) => ({ ...prev, [item_id]: !prev[item_id] }));
  };

  return (
    <>
      <Col md={6}>
        <div className="p-20 shadow rounded h-100">
          <strong className="text-secondary">User Details</strong>
          <div className="mt-2">
            <table className="table table-sm" style={{ tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <th
                    className="align-middle"
                    style={{ width: "180px", whiteSpace: "nowrap" }}
                  >
                    User Name :
                  </th>
                  <td className="align-middle">
                    <UserDetail
                      img={edit?.user_image}
                      name={edit?.user_name}
                      login_id={null}
                      id={edit?.user_id}
                      unique_id={edit?.employee_id}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                    Employee Id :
                  </th>
                  <td>{edit?.employee_id ?? "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                    From Date :
                  </th>
                  <td>{edit?.from_date ?? "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                    To Date :
                  </th>
                  <td>{edit?.to_date ?? "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                    Total Complaints :
                  </th>
                  <td>{edit?.total_complaints_count ?? "--"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Col>

      <Col md={6}>
        <div className="p-20 shadow rounded h-100">
          <strong className="text-secondary">Fund Summary</strong>
          <div className="mt-2">
            <table className="table table-sm" style={{ tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Total Transfer Amount :
                  </th>
                  <td>{summary?.total_transfer_amount != null ? formatAmountINR(summary.total_transfer_amount) : "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Punched Amount :
                  </th>
                  <td>{summary?.punched_amount != null ? formatAmountINR(summary.punched_amount) : "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Pending Amount :
                  </th>
                  <td>{summary?.pending_amount != null ? formatAmountINR(summary.pending_amount) : "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Fund Limit :
                  </th>
                  <td>{summary?.fund_limit != null ? formatAmountINR(summary.fund_limit) : "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Remaining Fund Limit :
                  </th>
                  <td>{summary?.remaining_fund_limit != null ? formatAmountINR(summary.remaining_fund_limit) : "--"}</td>
                </tr>
                <tr>
                  <th style={{ width: "200px", whiteSpace: "nowrap" }}>
                    Current Balance :
                  </th>
                  <td>{summary?.current_balance != null ? formatAmountINR(summary.current_balance) : "--"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Col>

      <Col md={12}>
        <div className="p-20 shadow rounded h-100">
          <strong className="text-secondary">Approved Expense Punch Data</strong>
          <div className="table-scroll mt-4">
            <Table striped hover className="text-body bg-new Roles">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th style={{ minWidth: "250px" }}>Item</th>
                  <th style={{ minWidth: "80px" }}>Price</th>
                  <th style={{ minWidth: "120px" }}>Total Approved Qty</th>
                  <th style={{ minWidth: "140px" }}>Total Approved Amount</th>
                  <th style={{ minWidth: "80px" }}>Details</th>
                </tr>
              </thead>
              <tbody>
                {uniqueItems.length > 0 ? (
                  uniqueItems.map((itm, idx) => (
                    <React.Fragment key={itm.item_id}>
                      {/* Item summary row */}
                      <tr>
                        <td>{idx + 1}</td>
                        <td>
                          <ImageViewer
                            src={
                              itm?.item_images
                                ? `${process.env.REACT_APP_API_URL}${itm?.item_images}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/no-image.png`
                            }
                          >
                            <img
                              width={30}
                              height={30}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                itm?.item_images
                                  ? `${process.env.REACT_APP_API_URL}${itm?.item_images}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/no-image.png`
                              }
                            />{" "}
                            {itm?.item_name}
                          </ImageViewer>
                        </td>
                        <td>{formatAmountINR(itm?.item_price)}</td>
                        <td>
                          <strong>{to3(itm.total_approved_qty)}</strong>
                        </td>
                        <td>
                          <strong>{formatAmountINR(itm.total_approved_amount || 0)}</strong>
                        </td>
                        <td>
                          <span
                            className={`cursor-pointer text-${expandedItems[itm.item_id] ? "danger" : "green"}`}
                            onClick={() => toggleExpand(itm.item_id)}
                          >
                            {expandedItems[itm.item_id] ? (
                              <BsChevronUp fontSize={"large"} />
                            ) : (
                              <BsChevronDown fontSize={"large"} />
                            )}
                          </span>
                        </td>
                      </tr>

                      {/* Expanded complaint breakdown rows */}
                      {expandedItems[itm.item_id] && (
                        <tr>
                          <td colSpan={6} className="p-0">
                            <div
                              style={{
                                backgroundColor: "#f8f9fa",
                                borderLeft: "4px solid #6c757d",
                                padding: "8px 16px",
                              }}
                            >
                              <table className="table table-sm table-bordered mb-0">
                                <thead>
                                  <tr style={{ backgroundColor: "#e9ecef" }}>
                                    <th>#</th>
                                    <th style={{ minWidth: "220px" }}>
                                      Complaint Id
                                    </th>
                                    <th style={{ minWidth: "100px" }}>
                                      Approved Qty
                                    </th>
                                    <th style={{ minWidth: "120px" }}>
                                      Approved Amount
                                    </th>
                                    <th style={{ minWidth: "160px" }}>
                                      Punch Date & Time
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {itm.complaint_rows.map((row, rIdx) => (
                                    <tr key={rIdx}>
                                      <td>{rIdx + 1}</td>
                                      <td>{row.complaint_unique_id}</td>
                                      <td>{row.item_approved_qty != null ? to3(row.item_approved_qty) : "--"}</td>
                                      <td>{row.approved_amount != null ? formatAmountINR(row.approved_amount) : "--"}</td>
                                      <td>{row.punch_at ?? "--"}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="d-flex justify-content-end my-2">
              Total Approved Amount{" "}
              <span className="fw-bold ms-1">
                {formatAmountINR(
                  uniqueItems.reduce(
                    (total, itm) => total + itm.total_approved_amount,
                    0
                  )
                )}
              </span>
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};

export default ViewExpenseApproveData;
